import React, { useEffect, useState } from "react";

import Loading from "../../Shared/Loading";
import Experience from "../Experience";

import Qualification from "../Qualification";


const Resume = () => {
  const [loading, setLoading] = useState(false);
  const [qualifications, setQualifications] = useState([]);

  useEffect(() => {
    fetch("https://personal-portfolio-server-lovat.vercel.app/education")
      .then((res) => res.json())
      .then((data) => {
        setQualifications(data);
        setLoading(true);
      });
  }, []);

  if (!loading) {
    return <Loading />;
  }

  return (
    <div
      className="resume min-h-full"
      data-aos="fade-up"
      data-aos-duration="2000"
    >
      <div className="resumeBody px-10 py-20">
        <h1
          className="text-5xl text-white font-extrabold 
           uppercase mb-20"
        >
          My
          <span className="text-primary"> Resume</span>
        </h1>

        {/* resume section  */}
        <Qualification qualifications={qualifications} />
      </div>

      {/* experience  */}
      <div className="resumeBody px-10 py-20">
        {/* resume section  */}
        <Experience />
      </div>

    </div>
  );
};

export default Resume;
